exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".format[data-v-938e231c],.icon[data-v-938e231c],.root-icon[data-v-938e231c]{display:-ms-flexbox;display:flex;-ms-flex-line-pack:center;align-content:center;-ms-flex-pack:center;justify-content:center;color:#fff}.icon[data-v-938e231c],.root-icon[data-v-938e231c]{width:32px;height:32px;border-radius:16px;color:inherit;-ms-flex-align:center;align-items:center}.format[data-v-938e231c]{height:25px;border-radius:2px;padding:2px 4px}.format span[data-v-938e231c]{line-height:21px;display:block;margin:auto;padding:0}.avatar[data-v-938e231c]{border-radius:50%;height:32px;width:32px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-938e231c","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/common/files/FormatBadge.vue
// module id = 1082
// module chunks = 22